module.exports = __webpack_public_path__ + "img/插图底纹@2x.a1b965b2.png";